import { Component } from '@angular/core';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PendingApplicationsService } from '../pending-applications.service';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { PendingApplicationDetails } from '../DTOs/pending-application-details';
import { SavePendingAppRequest } from '../DTOs/save-pending-app-request';
import { NumberOfEmployeesOption } from '../../sign-up/DTOs/number-of-employees-option';
import { MinorityCertificateType } from '../../sign-up/DTOs/minority-certificate-type';
import { MbscSelect } from '@mobiscroll/angular';

@Component({
  selector: 'app-edit-company-information-modal',
    templateUrl: './edit-company-information-modal.component.html',
    providers: [UIBlockingService, MbscSelect]
})
export class EditCompanyInformationModalComponent {
    constructor(private activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private pendingApplicationService: PendingApplicationsService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService) { }

    companyNameCtrl = new FormControl("companyName");
    employeeCountCtrl = new FormControl("employeeCount", [Validators.required]);
    businessPhoneCtrl = new FormControl("businessPhone");
    businessAddressCtrl = new FormControl("businessAddress");
    businessCityCtrl = new FormControl("businessCity");
    businessStateCtrl = new FormControl("businessState");
    businessZipCtrl = new FormControl("businessZip");
    minorityCertsCtrl = new FormControl("minorityCerts");

    manageCompanyInfoForm: FormGroup = new FormGroup({
        companyName: this.companyNameCtrl,
        employeeCount: this.employeeCountCtrl,
        businessPhone: this.businessPhoneCtrl,
        businessAddress: this.businessAddressCtrl,
        businessCity: this.businessCityCtrl,
        businessState: this.businessStateCtrl,
        businessZip: this.businessZipCtrl,
        minorityCerts: this.minorityCertsCtrl,
    });
    app: PendingApplicationDetails;
    validationTriggered = false;
    isBusy = false;
    numberOfEmployeesOptions: NumberOfEmployeesOption[] = [];
    minorityCertificateTypes: MinorityCertificateType[] = [];

    companyName() { return this.manageCompanyInfoForm.get('companyName').value }
    employeeCount() { return this.manageCompanyInfoForm.get('employeeCount').value }
    businessPhone() { return this.manageCompanyInfoForm.get('businessPhone').value }
    businessAddress() { return this.manageCompanyInfoForm.get('businessAddress').value }
    businessCity() { return this.manageCompanyInfoForm.get('businessCity').value }
    businessState() { return this.manageCompanyInfoForm.get('businessState').value }
    businessZip() { return this.manageCompanyInfoForm.get('businessZip').value }
    minorityCerts() { return this.manageCompanyInfoForm.get('minorityCerts').value }

    ngOnInit() {
        this.pendingApplicationService
            .getGeneralAppInfo()
            .subscribe(
                {
                    next: (data) => {
                        this.minorityCertificateTypes = data.minorityCertificateTypes;
                        this.numberOfEmployeesOptions = data.numberOfEmployeesOptions;
                    },
                    error: (err) => {
                        this.notificationService.error(err);
                    },
                    complete: () => {
                        this.resetManageCompanyForm();
                    }
                });
    }

    private resetManageCompanyForm(): void {
        this.manageCompanyInfoForm.reset();
        this.manageCompanyInfoForm.patchValue({
            companyName: this.app.companyName,
            employeeCount: this.app.employeeCount.value,
            businessPhone: this.app.businessPhone,
            businessAddress: this.app.businessAddress,
            businessCity: this.app.businessCity,
            businessState: this.app.businessState,
            businessZip: this.app.businessZip,
            minorityCerts: this.app.minorityCerts?.map(x => x.value),
        })
    }
    dismiss(): void {
        this.activeModal.dismiss();
    }
    saveCompanyInfo() {
        for (var i in this.manageCompanyInfoForm.controls) {
            this.manageCompanyInfoForm.controls[i].markAsTouched();
        }
        if (!this.manageCompanyInfoForm.valid) return;

        this.blockUI.start();
        var request = new SavePendingAppRequest(
            this.app.appId,
            this.companyName(),
            this.employeeCount(),
            this.businessPhone(),
            this.businessAddress(),
            this.businessCity(),
            this.businessState(),
            this.businessZip(),
            this.minorityCerts(),
            this.app.liaisonFirstName,this.app.liaisonLastName, this.app.liaisonEmail, this.app.liaisonPhone, this.app.liaisonTitle,
            this.app.membershipLevel.value, this.app.price, this.app.paymentType, this.app.isAutoRenew
        );

        this.pendingApplicationService.UpdatePendingAppInfo(request)
            .subscribe({
                next: (data) => {
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    console.log('Observable emitted the complete notification');
                    this.blockUI.stop();
                    this.activeModal.close();
                }
            })
    }
}
